import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/landing_page/LandingPage';
import Rsvp from './pages/rsvp/Rsvp';
import ThankyouMessage from './pages/thankyou_message/ThankyouMessage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<LandingPage />} />
        <Route path='/rsvp' element={<Rsvp />} />
        <Route path="/thankyou-message" element={<ThankyouMessage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
